// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill2","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M12.9999 12L10.0002 20.9989L7.93799 17.0619L4.00098 14.9996L12.9999 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"map-navigation"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12.9999 12L10.0002 20.9989L7.93799 17.0619L4.00098 14.9996L12.9999 12Z","mask":"props.overlapMaskUrl_fill2"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 6L3 6M19 20V3M21 16H17M7 3V10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12.9999 12L10.0002 20.9989L7.93799 17.0619L4.00098 14.9996L12.9999 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapNavigationIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-navigation',
    ref,
    icon: element,
  },
));

MapNavigationIcon.displayName = 'MapNavigationIcon';

export default MapNavigationIcon;
